module.exports = "<div data-component=\"change-questions-result\" class=\"step\" *ngIf=\"active\">\n\n\t<app-warning [message]=\"changeQuestionsData.message\" [type]=\"changeQuestionsData.success ? 'success' : 'error'\"></app-warning>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-security-questions/change-questions-result/change-questions-result.component.html
// module id = ../../../../../src/app/master/change-security-questions/change-questions-result/change-questions-result.component.html
// module chunks = main